export default {
  // landings
  getStarted: 'Get started',

  // site
  signup: 'Signup',
  registerEmailAlreadyExists: 'Register email already exists',
  welcomeSkip: 'Welcome skip',
  pickPage: {
    skip: 'Pick page skip',
    addProduct: 'Pick page add product',
  },
  addressValidationPopup: {
    open: 'Address validation popup',
    useAddress: 'Address validation use address',
    editAddress: 'Address validation edit address',
  },
  appStore: {
    badgeClick: 'App Store badge click',
    bannerClick: 'App Store banner click',
    banner: 'App Store banner',
  },
  newOnboarding: {
    mainPageOnboardingButton: 'Main page onboarding button', // SCNT-6562
  },
  linkToLogin: 'Link to login',
  emailFixed: 'Email fixed',
  emptyQueueClick: 'Empty queue click',
  casesBannerClick: 'Cases banner click',
  buyNow: 'Buy now',
  cardUpdateBannerClick: 'Card update banner click',
  cardUpdatePopup: 'Card update popup',
  burgerMenuClick: 'Burger menu click',
  burgerMenuLinkClick: 'Burger menu link click',
  burgerMenuInsideClick: 'Burger menu inside click',
  footerLinkClick: 'Footer link click',
  profileMenuClick: 'Profile menu click',
  desktopProfileMenuClick: 'Profile menu',
  paypalUpdateBannerClick: 'Paypal update banner click',
  paypalUpdateClick: 'Paypal update click',
  changeFrequencyClick: 'Change frequency click',
  writeReviewClick: 'Write review click',
  reviewSubmit: 'Review submit',
  subscribeNowLinkClick: 'Subscribe now link click',
  orderStatusLinkClick: 'Order status link click',
  productsInQueueLinkClick: 'Products in queue link click',
  ratedProductsLinkClick: 'Rated products link click',
  reviewsWrittenLinkClick: 'Reviews written link click',
  trackingNumberClick: 'Tracking number click',
  collectionAddToQueueAllButton: 'Collection add to queue all button',
  addToQueue: 'Add to queue front',
  addToCart: 'Add to cart',
  searchInputClick: 'Search input click',
  buyGiftSubscriptionClick: 'Buy gift subscription click',
  buyGiftSubscriptionStepComplete: 'Buy gift subscription step complete',
  giftSelect: 'Gift select',
  buyGiftCardClick: 'Buy gift card click',
  buyGiftCardStepComplete: 'Buy gift card step complete',
  navigationMenuClick: 'Navigation menu click',
  subscriptionReminderPopup: 'Subscription reminder popup',
  quickViewClick: 'Quick view click',
  quizStepComplete: 'Quiz step complete',
  smartSearchTagClick: 'Smart search tag click',
  editReviewClick: 'Edit review click',
  shareButtonClick: 'Share button click',
  skipMonthClick: 'Skip month click',
  unsubscribeReason: 'Unsubscribe reason',
  cancelSubscriptionClick: 'Cancel subscription click',
  cancelSubscriptionStepComplete: 'Cancel subscription step complete',
  resubscribeClick: 'Resubscribe click',
  upgradeSubscriptionClick: 'Upgrade subscription click',
  unpauseClick: 'Unpause click',
  subscriptionUnpausePopup: 'Subscription unpause popup',
  optOutPremiumPopup: 'Opt out premium popup',
  premiumProductDescriptionClick: 'Premium product description click',
  thankYouQueuePopup: 'Thank you queue popup',
  thankYouQueuePopupClick: 'Thank you queue popup click',
  search: {
    bestsellersClick: 'Search bestsellers click',
    brandClick: 'Search brand click',
    brandUnavailableClick: 'Search brand unavailable click',
    noteClick: 'Search note click',
    pageClick: 'Search page click',
    cancel: 'Search cancel',
    nameClick: 'Search name click',
    nameUnavailableClick: 'Search name unavailable click',
    suggestionClick: 'Search suggestion click',
    query: 'Search query',
  },
  queueProductRemove: 'Queue product remove',
  queueProductMove: 'Queue product move',
  sameProductPopup: 'Same product popup',
  cartClick: 'Cart click',

  // page visit
  pageVisit: {
    productPage: 'Product page',
    productOfTheMonthPage: 'Product of the month page',
  },

  recommendedProductView: 'Recommended product view',

  mainPageLoginClick: 'Main page login click',

  mobileMenuFirstClick: 'Mobile menu first click',

  promote: { // SB-121
    buyQueue: 'Buy queue click',
    casesBanner: 'Cases banner click',
    subscriptionUpgrade: 'Subscription upgrade click',
  },

  productCard: {
    readMoreClick: 'Read more click',
    seeDetailsClick: 'See details click',
  },

  mainPagePopularNotesClick: 'Main page note select', // SB-168
  noteProductsPage: 'Filter note results page', // SB-168

  collectionForSale: {  // SB-164
    visit: 'Collection set page',
    continueClick: 'Collection set continue click',
    bannerClick: 'Collection set banner click',
    collections: 'Collections set page',
    coverClick: 'Collection set cover click',
  },

  productFeedBanner: { // SB-210
    appear: 'Upgrade banner appear',
    click: 'Upgrade banner click',
  },

  upgradePrepaidPlansPage: {   // SB-212
    visit: 'Prepaid plans page',
    upgradeOptionClick: 'Prepaid plan select',
  },

  collectionPage: 'Collection page', // SB-374

  unsubscribeReasonsPopup: { // SB-395
    open: 'Unsubscribe reasons popup',
    close: 'Unsubscribe reasons exit',
  },
}
